
import { Component, Vue } from 'nuxt-property-decorator'
import { Context } from '@nuxt/types'
import AppTopItem from '~/components/AppTopItem.vue'
import { Artist } from '~/types/Artist'
import { ItemModel } from '~/types/ItemModel'
import AmpAppTopItem from '~/components/amp/AmpAppTopItem.vue'

@Component({
  // @ts-ignore
  amp: 'hybrid',
  ampLayout: 'amp',
  components: { AmpAppTopItem, AppTopItem }
})
export default class extends Vue {
  upperBlock: ItemModel[] = []
  middleBlock: ItemModel[] = []
  lowerBlock: ItemModel[] = []
  artist: Artist[] = []
  component: any = this.$isAMP ? AmpAppTopItem : AppTopItem

  head () {
    return {
      title: this.$t('head.title.top-artists'),
      meta: [
        { hid: 'description', name: 'description', content: this.$t('head.description.top-artists') },
        { hid: 'og:title', name: 'og:title', content: this.$t('head.title.top-artists') },
        { hid: 'og:description', name: 'og:description', content: this.$t('head.description.top-artists') },
        { hid: 'og:image', name: 'og:image', content: require('~/assets/img/logo-black.svg') },
        { hid: 'og:type', name: 'og:type', content: 'website' },
        { hid: 'og:url', name: 'og:url', content: process.env.API_ENDPOINT + this.$route.fullPath }
      ]
    }
  }

  async asyncData (context: Context) {
    const artist: Artist[] = await context.$axios.get(
      process.env.API_ENDPOINT + '/api/v3/artists/top',
      // process.env.API_ENDPOINT + '/api/v3/sandbox-artists/list',
      {
        // @ts-ignore
        cache: true,
        // @ts-ignore
        requireToken: false
      }
    ).then(response => response.data)

    const upperBlock = [{ number: 1, item: artist[0] }]
    const middleBlock = artist.slice(1, 4).map((item, index) => ({
      number: index + 2,
      item
    }))
    const lowerBlock = artist.slice(4).map((item, index) => ({
      number: index + 5,
      item
    }))

    return {
      upperBlock,
      middleBlock,
      lowerBlock,
      artist
    }
  }
}
